(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shree-scroll-stories"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('shree-scroll-stories')){
class ShreeScrollStories extends HTMLElement{
connectedCallback(){
this.panels=[...this.querySelectorAll('[data-story-panel]')];
this.images=[...this.querySelectorAll('[data-story-image]')];
this.update=()=>{this.frame=0;const point=innerHeight*.55;let active=0;this.panels.forEach((panel,i)=>{if(panel.getBoundingClientRect().top<=point)active=i});this.images.forEach((image,i)=>image.classList.toggle('is-active',i===active))};
this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.update)};
this.select=e=>{const panel=e.target.closest('[data-story-panel]');if(panel){this.images.forEach((image,i)=>image.classList.toggle('is-active',i===Number(panel.dataset.storyPanel)))}};
addEventListener('scroll',this.schedule,{passive:true,capture:true});addEventListener('resize',this.schedule);this.addEventListener('shopify:block:select',this.select);this.update();
}
disconnectedCallback(){removeEventListener('scroll',this.schedule,true);removeEventListener('resize',this.schedule);this.removeEventListener('shopify:block:select',this.select);cancelAnimationFrame(this.frame)}
}
customElements.define('shree-scroll-stories',ShreeScrollStories);
}

  } catch(e) { console.error(e); }
})();
})();
